// import {bootstrapApplication} from '@angular/platform-browser';
// import {AppComponent} from './app/app.component';
// import {appConfig} from './app/app.config';


// bootstrapApplication(AppComponent, appConfig)
//   .catch(err => console.error(err));

// main.ts - Updated for better hydration handling
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { CURRENT_ENV } from './app/config/env-config';

// Enhanced bootstrap with better error handling
bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    if (CURRENT_ENV !== 'qa' && CURRENT_ENV !== 'prod') {
    //  console.log('Application bootstrapped successfully');
    }
    // Optional: Check if hydration completed successfully
    if (typeof window !== 'undefined') {
      if (CURRENT_ENV !== 'qa' && CURRENT_ENV !== 'prod') {
      //  console.log('Client-side bootstrap completed');
      }
    }
  })
  .catch(err => {
    if (CURRENT_ENV !== 'qa' && CURRENT_ENV !== 'prod') {
    //  console.error('Bootstrap error:', err);
    }
    // Check if it's a hydration-related error
    if (err?.message?.includes('hydration') ||
      err?.message?.includes('ApplicationRef.isStable')) {
      if (CURRENT_ENV !== 'qa' && CURRENT_ENV !== 'prod') {
       // console.warn('Hydration error detected:', err.message);
      }

      // You could implement fallback logic here if needed
      // For now, just log and let Angular handle it
    }

    // Re-throw to maintain error handling
    throw err;
  });